import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ErrorContainer,
  ErrorContent,
  ErrorTitle,
  ErrorSubtitle,
  ErrorMessage,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton,
  CityImage
} from "./errorPage.styles";
import City from "assets/images/city-vector.jpg";

export const ErrorPage = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <ErrorContainer>
      <ErrorContent>
        <ErrorTitle>404</ErrorTitle>
        <ErrorSubtitle>Página não encontrada</ErrorSubtitle>
        <CityImage src={City} />
        <ErrorMessage>
          A página que você está procurando não existe ou foi movida.
        </ErrorMessage>
        <ButtonsContainer>
          <PrimaryButton onClick={goToHome}>
            Ir para a Home
          </PrimaryButton>
          <SecondaryButton onClick={goBack}>
            Voltar
          </SecondaryButton>
        </ButtonsContainer>
      </ErrorContent>
    </ErrorContainer>
  );
};
